module.exports = __webpack_public_path__ + "ea481508055d9b232efc1a54dcb287cc.png";